export const ApplicantEmploymentDetailStatuses = [
  {
    value: "Disability",
    title: "Disability",
  },
  {
    value: "FullTimeEmployed",
    title: "Full Time Employed",
  },
  {
    value: "Homemaker",
    title: "Homemaker",
  },
  {
    value: "LongTermBenefits",
    title: "Long Term Benefits",
  },
  {
    value: "Other",
    title: "Other",
  },
  {
    value: "PartTimeEmployed",
    title: "Part Time Employed",
  },
  {
    value: "Retired",
    title: "Retired",
  },
  {
    value: "SelfEmployed",
    title: "Self Employed",
  },
  {
    value: "Student",
    title: "Student",
  },
  {
    value: "TemporarilyEmployed",
    title: "Temporarily Employed",
  },
  {
    value: "Unemployed",
    title: "Unemployed",
  },
];

export const ApplicantEmploymentTypeStatuses = [
  {
    value: "DNOD",
    title:
      "Director or Shareholder less than 25% share, no dividends or share of net profits",
  },
  {
    value: "DWDV",
    title:
      "Director or Shareholder less than 25% share, getting dividends or share of net profits",
  },
  {
    value: "DMDV",
    title: "Director or Shareholder greater than or equal to 25% share",
  },
  {
    value: "FTC",
    title: "Fixed term contract",
  },
  {
    value: "PERM",
    title: "Permanent",
  },
  {
    value: "SCFT",
    title: "Sub-contractor fixed term",
  },
  {
    value: "SCOE",
    title: "Sub-contractor open ended",
  },
  {
    value: "ZHC",
    title: "Zero hours contract",
  },
  {
    value: "O",
    title: "Other",
  },
];

export const ApplicantEmploymentOtherIncomeSources = [
  {
    value: "AdoptionAllowance",
    title: "Adoption Allowance",
  },
  {
    value: "Agency",
    title: "Agency",
  },
  {
    value: "AttendanceAllowance",
    title: "Attendance Allowance",
  },
  {
    value: "BankNursing",
    title: "Bank Nursing",
  },
  {
    value: "Bonus",
    title: "Bonus",
  },
  {
    value: "Bursary",
    title: "Bursary",
  },
  {
    value: "CarAllowance",
    title: "Car Allowance",
  },
  {
    value: "CarersAllowance",
    title: "Carers Allowance",
  },
  {
    value: "ChildBenefit",
    title: "Child Benefit",
  },
  {
    value: "ChildSupportAgency",
    title: "Child Support Agency",
  },
  {
    value: "ChildTaxCredit",
    title: "Child Tax Credit",
  },
  {
    value: "PersonalIndependentPaymentOrDLA",
    title: "Personal Independent Payment (PIP) / DLA",
  },
  {
    value: "Dividends",
    title: "Dividends",
  },
  {
    value: "EmploymentAndSupportAllowance",
    title: "Employment and Support Allowance",
  },
  {
    value: "FosterCareAllowance",
    title: "Foster Care Allowance",
  },
  {
    value: "IncapacityBenefit",
    title: "Incapacity Benefit",
  },
  {
    value: "IncomeSupport",
    title: "Income Support",
  },
  {
    value: "IndustrialInjuriesBenefit",
    title: "Industrial Injuries Benefit",
  },
  {
    value: "InsurancePolicies",
    title: "Insurance Policies",
  },
  {
    value: "Invalidity",
    title: "Invalidity",
  },
  {
    value: "Investment",
    title: "Investment",
  },
  {
    value: "JobSeekersAllowance",
    title: "Job Seekers Allowance",
  },
  {
    value: "Lodgers",
    title: "Lodgers",
  },
  {
    value: "Maintenance",
    title: "Maintenance",
  },
  {
    value: "Maternity",
    title: "Maternity",
  },
  {
    value: "Mobility",
    title: "Mobility",
  },
  {
    value: "MoneyFromFamily",
    title: "Money From Family",
  },
  {
    value: "Overtime",
    title: "Overtime",
  },
  {
    value: "PartTimeJob",
    title: "Part-time Job",
  },
  {
    value: "PartTimeSelfEmployment",
    title: "Part-time Self-employment",
  },
  {
    value: "PensionCredit",
    title: "Pension Credit",
  },
  {
    value: "PrivatePension",
    title: "Private Pension",
  },
  {
    value: "RentalIncomeTotal",
    title: "Rental Income (Total)",
  },
  {
    value: "SelfEmployedSalary",
    title: "Self Employed Salary",
  },
  {
    value: "SevereDisabilityLivingAllowance",
    title: "Severe Disability Living Allowance",
  },
  {
    value: "StatePension",
    title: "State Pension",
  },
  {
    value: "StatutorySickPay",
    title: "Statutory Sick Pay",
  },
  {
    value: "WarPension",
    title: "War Pension",
  },
  {
    value: "WidowsPensionPrivate",
    title: "Widows Pension - Private",
  },
  {
    value: "WidowsPensionState",
    title: "Widows Pension - State",
  },
  {
    value: "WorkingTaxCredit",
    title: "Working Tax Credit",
  },
  {
    value: "Other",
    title: "Other",
  },
];
